import React, { useState } from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IP_URL from '../connect';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px;
  flex-grow: 1;
  background: linear-gradient(135deg, #e0f7fa 0%, #f9f9f9 100%);

  @media (max-width: 768px) {
    padding: 20px 10px;
  }
`;

const Card = styled.div`
  background-color: white;
  width: 100%;
  max-width: 500px;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  }

  @media (max-width: 600px) {
    padding: 20px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 25px;
  color: #007bff;
  font-size: 1.6rem;
  font-weight: bold;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Label = styled.label`
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
`;

const InputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 95%;
  padding: 10px 40px 10px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #007bff;
  }

  @media (max-width: 600px) {
    padding: 10px ;
  }
`;

const PasswordToggle = styled.div`
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #007bff;
`;

const AddBtn = styled.button`
  background-color: ${(props) => (props.disabled ? '#9e9e9e' : '#00bcd4')};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  transition: 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.disabled ? '#9e9e9e' : '#0097a7')};
  }
`;

const AddOrganization = () => {
  const [accountType] = useState('admin');
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { token } = useSelector(selectUser);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userName || !password || !phoneNumber || !email) {
      window.toast.warn("Please fill in all required fields!");
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(`${IP_URL}/organization/add`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          accountType,
          userName,
          phoneNumber,
          email,
          password,
        }),
      });

      const data = await response.json();

      if (data.success) {
        toast.success("✅ Organization added successfully!");
        setUserName('');
        setPassword('');
        setPhoneNumber('');
        setEmail('');
        setTimeout(() => navigate('/organizations'), 1500);
      } else {
        toast.error(data.message || "Error creating organization.");
      }
    } catch (error) {
      console.error("Failed to create organization:", error);
      toast.error("Network or server error!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PageWrapper>
      <Navbar showMenuButton toggleSidebar={toggleSidebar} />
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Content>
        <Card>
          <Title>Add New Organization</Title>

          <Form onSubmit={handleSubmit}>
            <div>
              <Label>Phone Number</Label>
              <PhoneInput
                country="ke"
                value={phoneNumber}
                onChange={setPhoneNumber}
                inputStyle={{
                  width: '100%',
                  borderRadius: '8px',
                  height: '42px',
                }}
                enableSearch
              />
            </div>

            <div>
              <Label>Organization Name</Label>
              <Input
                type="text"
                placeholder="Enter Organization Name"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>

            <div>
              <Label>Password</Label>
              <InputGroup>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <PasswordToggle onClick={togglePasswordVisibility}>
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </PasswordToggle>
              </InputGroup>
            </div>

            <div>
              <Label>Email</Label>
              <Input
                type="text"
                placeholder="Enter Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <AddBtn
              type="submit"
              disabled={
                submitting ||
                !userName ||
                !password ||
                !phoneNumber ||
                !email
              }
            >
              {submitting ? 'Adding...' : 'Add Organization'}
            </AddBtn>
          </Form>
        </Card>
      </Content>

      <Footer />
    </PageWrapper>
  );
};

export default AddOrganization;
